import { useState } from "react";
import {
  sendOtpAPI,
  verifyOtpAPI,
} from "../../services/allAPI";

export const useEmailVerification = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // SEND OTP
  const sendOtp = async ({ email, purpose }) => {
    setError("");
    try {
      setLoading(true);
      const res = await sendOtpAPI({ email, purpose });
      return res;
    } catch (err) {
      setError(err?.response?.data?.detail || "Failed to send OTP");
      throw err;
    } finally {
      setLoading(false);
    }
  };

  // VERIFY OTP
  const verifyOtp = async (payload) => {
    setError("");
    try {
      setLoading(true);
      const res = await verifyOtpAPI(payload);
      return res;
    } catch (err) {
      setError("Invalid OTP");
      console.error(err?.response?.data || err);
      throw err;
    } finally {
      setLoading(false);
    }
  };

  // RESEND OTP
  const resendOtp = async ({ email, purpose }) => {
    try {
      const res = await sendOtpAPI({ email, purpose });
      return res;
    } catch (err) {
      setError(err?.response?.data?.detail || "Failed to resend OTP");
      throw err;
    }
  };


  return {
    sendOtp,
    verifyOtp,
    resendOtp,
    loading,
    error,
  };
};